import React, { useEffect, useState } from "react";
import client, { formatErr } from "../../lib/api";
import { toast } from "sonner";
import * as Icons from "lucide-react";
import { Plus, Trash2 } from "lucide-react";

export default function AdminBadges() {
    const [list, setList] = useState([]);
    const [show, setShow] = useState(false);
    const [form, setForm] = useState({ name: "", description: "", icon: "Trophy", unlock_condition: "" });

    const load = () => client.get("/admin/badges").then((r) => setList(r.data));
    useEffect(() => {
        load();
    }, []);

    const create = async (e) => {
        e.preventDefault();
        try {
            await client.post("/admin/badges", form);
            toast.success("Badge created");
            setForm({ name: "", description: "", icon: "Trophy", unlock_condition: "" });
            setShow(false);
            load();
        } catch (err) {
            toast.error(formatErr(err));
        }
    };

    const remove = async (id) => {
        if (!window.confirm("Delete badge?")) return;
        await client.delete(`/admin/badges/${id}`);
        load();
    };

    return (
        <div>
            <div className="flex items-end justify-between">
                <div>
                    <span className="label-cap text-xs text-neon-orange">Manage</span>
                    <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">Badges</h1>
                </div>
                <button
                    onClick={() => setShow(!show)}
                    data-testid="adm-new-badge"
                    className="btn-neon px-4 py-2 flex items-center gap-2"
                >
                    <Plus size={16} /> New
                </button>
            </div>

            {show && (
                <form onSubmit={create} className="mt-6 surface-2 p-4 space-y-3" data-testid="adm-badge-form">
                    <input
                        required
                        placeholder="Name"
                        data-testid="bf-name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        className={inp}
                    />
                    <input
                        required
                        placeholder="Description"
                        data-testid="bf-desc"
                        value={form.description}
                        onChange={(e) => setForm({ ...form, description: e.target.value })}
                        className={inp}
                    />
                    <input
                        placeholder="Icon (lucide-react name e.g. Trophy)"
                        data-testid="bf-icon"
                        value={form.icon}
                        onChange={(e) => setForm({ ...form, icon: e.target.value })}
                        className={inp}
                    />
                    <input
                        placeholder="Unlock condition"
                        data-testid="bf-cond"
                        value={form.unlock_condition}
                        onChange={(e) => setForm({ ...form, unlock_condition: e.target.value })}
                        className={inp}
                    />
                    <button type="submit" data-testid="bf-submit" className="btn-primary w-full py-3">
                        Create Badge
                    </button>
                </form>
            )}

            <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-3">
                {list.map((b) => {
                    const Icon = Icons[b.icon] || Icons.Award;
                    return (
                        <div key={b.id} className="surface-1 p-4 text-center" data-testid={`adm-badge-${b.id}`}>
                            <div className="w-14 h-14 mx-auto rounded-full bg-neon-green/15 border border-neon-green flex items-center justify-center">
                                <Icon size={20} className="text-neon-green" />
                            </div>
                            <div className="font-display font-bold uppercase text-sm mt-2">{b.name}</div>
                            <div className="text-xs text-zinc-500 mt-1 line-clamp-2">{b.description}</div>
                            <button
                                onClick={() => remove(b.id)}
                                data-testid={`adm-badge-del-${b.id}`}
                                className="mt-2 w-full surface-3 py-1.5 label-cap text-[10px] hover:border-neon-orange flex items-center justify-center gap-1 text-neon-orange"
                            >
                                <Trash2 size={10} /> Delete
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

const inp = "w-full bg-charcoal-700 border border-charcoal-500 px-3 py-2 text-white text-sm focus:border-neon-orange focus:outline-none";
